<template>
  <div
    class="appointment-card"
    :class="`appointment-card--${appointmentModalityClass}`"
    role="button"
    tabindex="0"
    @click="$emit('click', appointment)"
    @keydown.enter.prevent="$emit('click', appointment)"
    @keydown.space.prevent="$emit('click', appointment)"
  >
    <div class="appointment-card__header">
      <span class="appointment-card__date">
        <i class="pi pi-calendar mr-1" />
        {{ formattedDate }}
      </span>
      <span class="appointment-card__time">
        <i class="pi pi-clock mr-1" />
        {{ formattedTime }}
      </span>
      <span
        class="appointment-card__badge"
        :class="`appointment-card__badge--${stateBadgeModifier}`"
      >
        {{ stateLabel }}
      </span>
    </div>
    <div class="appointment-card__body">
      <h4 class="appointment-card__title">{{ serviceName }}</h4>
      <p v-if="consultantName" class="appointment-card__consultant">
        <i class="pi pi-user mr-1" />
        <span class="appointment-card__consultant-label">Consultor:</span>
        {{ consultantName }}
      </p>
      <div class="appointment-card__meta">
        <span class="appointment-card__type">
          <i :class="typeIcon" />
          {{ typeLabel }}
        </span>
        <span v-if="showOfficeLocality" class="appointment-card__type">
          <i class="pi pi-map-marker mr-1" />
          {{ officeLocality }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

/** Alinhado com App\Entity\Maestro\Ag\Appointment (enum state) */
const STATE_LABELS = {
  approved: "Aprovado",
  pending: "Pendente",
  rejected: "Rejeitado",
  canceled: "Cancelado",
  "no-show": "Não compareceu",
  deleted: "Eliminado",
  done: "Realizado",
  "pending-payment": "Pagamento pendente",
  "approved-unpaid": "Aprovado",
};

export default {
  name: "AppointmentCard",
  props: {
    appointment: { type: Object, required: true },
  },
  emits: ["click"],
  computed: {
    formattedDate() {
      if (!this.appointment.startDate) return "";
      return dayjs.utc(this.appointment.startDate).local().format("DD/MM/YYYY");
    },
    formattedTime() {
      if (!this.appointment.startDate) return "";
      return dayjs.utc(this.appointment.startDate).local().format("HH:mm");
    },
    rawState() {
      return (this.appointment.state || "").toLowerCase();
    },
    stateLabel() {
      return STATE_LABELS[this.rawState] || this.appointment.state || "";
    },
    /** Classe CSS segura (evita caracteres inválidos no seletor) */
    stateBadgeModifier() {
      return this.rawState.replace(/[^a-z0-9-]/g, "") || "unknown";
    },
    appointmentModality() {
      return (
        this.appointment.appointmentType || this.appointment.type || "online"
      );
    },
    appointmentModalityClass() {
      const t = this.appointmentModality;
      if (t === "on-site") return "on-site";
      if (t === "hybrid") return "hybrid";
      return "online";
    },
    typeIcon() {
      if (this.appointmentModality === "online") return "pi pi-video mr-1";
      if (this.appointmentModality === "hybrid") return "pi pi-globe mr-1";
      return "pi pi-map-marker mr-1";
    },
    typeLabel() {
      if (this.appointmentModality === "online") return "Online";
      if (this.appointmentModality === "hybrid") return "Online ou presencial";
      return "Presencial";
    },
    serviceName() {
      return (
        this.appointment.servicePriceName || this.appointment.title || "Serviço"
      );
    },
    consultantName() {
      const n = this.appointment.consultantName;
      return n && String(n).trim() ? String(n).trim() : "";
    },
    officeLocality() {
      const n = this.appointment.officeName;
      return n && String(n).trim() ? String(n).trim() : "";
    },
    showOfficeLocality() {
      return this.appointmentModality === "on-site" && !!this.officeLocality;
    },
  },
};
</script>
